
import Vue from 'vue';
import InstantSearch from 'vue-instantsearch';

Vue.use(InstantSearch);

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Vue.component('project-device', require('./components/ProjectDevice.vue').default);
Vue.component('hamburger-navigation', require('./components/HamburgerNavigation.vue').default);
Vue.component('logo', require('./components/Logo.vue').default);
Vue.component('card', require('./components/Card.vue').default);
Vue.component('conversation', require('./components/Conversation.vue').default);
Vue.component('articles-overview', require('./components/ArticlesOverview.vue').default);
Vue.component('employee-refinement', require('./components/EmployeeRefinement.vue').default);
Vue.component('accordion', require('./components/Accordion.vue').default);
Vue.component('contact-form', require('./components/ContactForm.vue').default);

if (document.getElementById('app') !== null) {
    const app = new Vue({
        el: '#app',
        data: function() {
            return {
                "navigationIsOpen": false
            }
        },
        methods: {
            toggleNav: function() {
                this.navigationIsOpen = !this.navigationIsOpen;
            }
        }
    });
}
